import React, { createContext, useMemo } from "react";

import { useAuth } from "../context/AuthContext";
import useSiteSettings from "../hooks/useSiteSettings";

export const SettingContext = createContext({
  sportsEnabled: true,
  userdetail: null,
});

const resolveSportsEnabled = (settings = {}) => {
  const value =
    settings.sports_enabled ??
    settings.sportsEnabled ??
    settings.is_sports_enabled ??
    settings.is_use_sports;
  return value === undefined ? true : value !== false && value !== 0 && value !== "0";
};

export const SettingContextProvider = ({ children }) => {
  const { user } = useAuth();
  const { settings } = useSiteSettings();
  const value = useMemo(
    () => ({
      sportsEnabled: resolveSportsEnabled(settings),
      userdetail: user?.profile || null,
    }),
    [settings, user?.profile]
  );

  return <SettingContext.Provider value={value}>{children}</SettingContext.Provider>;
};
